<template>
  <div class="workerorderindex">
    <top></top>
    <div class="nav">
      <router-link style="color:rgb(31, 55, 61);"  :to="{ path: indexUrl}">
          <span>首页</span>
      </router-link>
      <span class="navbread" v-for="item in questionclass">{{'>'+item}}</span>
      <!-- <a class="btna color" href="#/myorder" :style="{backgroundColor:boxBodyColor}">我的工单</a> -->
      <router-link class="btna color" :to="{ path: '/myorder'}" :style="{backgroundColor:boxBodyColor}">我的工单</router-link>
    </div>
    <div class="content" v-dompurify-html="text">
    </div>
    <el-button class="color btn" type="primary" @click="commit" :style="{backgroundColor:boxBodyColor}">下一步</el-button>
  </div>
</template>

<script>
import * as Urls from '../url.js'
import top from '../workorder/top.vue'
import axios from '@/utils/request.js'
export default {
  name: 'workinformation',
  components: {
    top
  },
  data () {
    return {
      kefuis:false,
      questionclass:["测试"],
      basurl:Urls.baseurl,
      text:"",
      md5:"",
      href:"",
      indexUrl: '',
      boxBodyColor:'',
      logoUrl:'',
      companyName:'',
      displayMode:''
    }
  },
  mounted(){
      var vm=this;
      vm.boxBodyColor = sessionStorage.getItem('boxBodyColor')
      vm.companyName = sessionStorage.getItem('companyName')
      vm.logoUrl = sessionStorage.getItem('logoUrl');
      vm.displayMode = sessionStorage.getItem('displayMode')
      this.md5=sessionStorage.getItem("md5");
      this.indexUrl = sessionStorage.getItem('indexUrl')
      if (this.indexUrl) {
        this.indexUrl += '?v='+this.md5
      }
      this.questionclass=[];
      // this.questionclass.push(sessionStorage.getItem("navname"));
      // this.questionclass.push("单据说明")
      setTimeout(function(){
        console.log(sessionStorage.getItem("navname"));
        vm.questionclass.push(sessionStorage.getItem("navname"));
        vm.questionclass.push("单据说明");
      }, 100)
    this.href= this.$route.query.id

    axios.get(this.basurl+'/api/visitor/wo/workOrderDesc/'+this.href+'?visitorMd5Code='+this.md5).then(function(response){
        if(response.data.code==1){
          vm.text=response.data.data.note;
        }
      })
      //判断客服是否显示
      axios.get(this.basurl+'/api/visitor/product/conf/showOnlineService?visitorMd5Code='+this.md5).then(function(response){
        if(response.data.code==1){
          vm.kefuis=true;
        }
      })
  },
  methods:{
    commit() {
      this.$router.replace({
        path: 'workcommit',
        query:{
          "id":this.href,
          source: this.$route.query.source,
        }
      });
      //window.location.href="#/workcommit?id="+this.href;
    },
      //判断跳转页面
    kefugo() {
        axios.get(this.basurl+'/api/visitor/product/conf/redirectToOnlineService?visitorMd5Code='+this.md5).then(function(response){
          //console.log(response)

          if(response.data.code==1) {
            var obj=response.data.data;

            if(obj.imStatus==" waiting"){

              window.location.href="#/imLineUp";

            }else if(obj.imStatus=="chatting"){

               window.location.href="#/imSession";
            }else{
                if(obj.target==1){
                  window.location.href="#/spirit";
                }
                if(obj.target==2){
                  window.location.href="#/imDirectory";
                }
            }
          }
        })
    }
  }
}
</script>

<style scoped>
  .top .title_img{
  display: inline-block;
  float: left;
  height: 35px;
  width: auto;
  margin: 5px 0 5px 20px;
}
.top .title_2{
  color:#fff;
  display: inline-block;
  float: left;
  margin-left:20px;
}
.top .title_2 span{
  font-size: 16px
}
  .btn{
    width: 100px;
    display: block;
    margin: 0 auto;
    margin-top: 30px;
  }
  .content{
    width: 470px;
    overflow: hidden;
    border-radius: 6px;
    margin:0 auto;
    font-size:14px;
    margin-top: 30px;
  }
 .workerorderindex{
  background: #f8f8f8;
  width: 100%;
  height: 100%;
 }
 .color{
  background: #009688;
 }
 .top{
   height: 46px;
   width: 100%;
 }
 .logo{
  margin-left: 20px;
  width: 140px;
  height: 34px;
  margin-top: 6px;
 }
 .top img,.top span{
  display: block;
  float: right;
  color: #fff;
  font-size:14px;
  cursor: pointer;
 }
 .top span{
  line-height: 46px;
  margin-left: 10px;
 }
 .kefu{
  position: absolute;
  right: 86px;
  margin-top: 11px;
 }
 .nav{
  width: 560px;
  margin:0 auto;
  height: 45px;
  border-bottom: 1px solid #000;
  font-size: 14px;
 }
 .nav span{
  line-height: 45px;
  color: #5987c2;
   font-weight:bold;
  text-decoration: underline;
 }
  .nav .btna{
    display: block;
    color: white;
    font-size: 14px;
    width: 70px;
    height: 24px;
    float: right;
    border-radius: 4px;
    text-align:center;
    line-height: 24px;
    margin-top: 11px;
  }
  .nav .navbread{
    text-decoration: none;
    color: #000;
    font-weight:bold;
  }

</style>



// WEBPACK FOOTER //
// src/components/workorder/workinformation.vue?c4a24cc8